import { Injectable } from '@angular/core';
import { Subject, BehaviorSubject } from 'rxjs';
import { MainLayoutComponent } from '../main-layout/main-layout.component';

@Injectable({
  providedIn: 'root'
})
export class MainLayoutService {

  mainlayoutComp: MainLayoutComponent;
  /** 啟用Loader mask的等候逾時 */
  EnableLoaderTimeout = true;
  constructor() { }
  public getMainHeight() {
    return this.mainlayoutComp?.mainContent?.nativeElement?.clientHeight ?? 0;
  }

  private isShowMenuSubject = new BehaviorSubject<boolean>(true);
  isShowMenu$ = this.isShowMenuSubject.asObservable();

  private switchMenuSubject = new BehaviorSubject<boolean>(false);
  switchMenu$ = this.switchMenuSubject.asObservable();

  private isShowLoaderSubject = new BehaviorSubject<boolean>(false);
  isShowLoader$ = this.isShowLoaderSubject.asObservable();

  
  private isShow隱形LoaderSubject = new BehaviorSubject<boolean>(false);
  isShow隱形Loader$ = this.isShow隱形LoaderSubject.asObservable();

  private isShowErrorSubject = new BehaviorSubject<any>(null);
  isShowError$ = this.isShowErrorSubject.asObservable();


  // show menu
  showMenu() {
    this.isShowMenuSubject.next(true);
  }
  // hide menu
  hideMenu() {
    this.isShowMenuSubject.next(false);
  }
  // switch menu
  switchMenu() {
    this.switchMenuSubject.next(true);
  }
  // show loader
  showLoader() {

    this.isShowLoaderSubject.next(true);
  }
  // show loader
  hideLoader() {
      setTimeout(() => {
        this.isShowLoaderSubject.next(false);
      }, 500);
  }

  // show 隱形loader
  showLoader2() {
    this.isShow隱形LoaderSubject.next(true);
  }
  // show loader
  hideLoader2() {
    this.isShow隱形LoaderSubject.next(false);
  }
  showError(error: any) {
    this.isShowErrorSubject.next(error);
  }
  async openQRCodeScanner(): Promise<string> {
    return await this.mainlayoutComp.openQRCodeScanner();
  }
  closeQRCodeScanner() {
    this.mainlayoutComp.closeQRCodeScanner();
  }
  async openQRCodeReader(): Promise<string> {
    return await this.mainlayoutComp.openQRCodeReader();
  }
  closeQRCodeReader() {
    this.mainlayoutComp.closeQRCodeReader();
  }
  hidePageTitle() {
    this.mainlayoutComp.pageTitle = '';
  }
  playNotifySound() {
    this.mainlayoutComp.playNotifySound();
  }
}
